import { Injectable, TemplateRef } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  toasts: any[] = [];

  show(textOrTpl: string | TemplateRef<any>, options: any = {}) {
    this.toasts.push({ textOrTpl, ...options });
  }

  success(textOrTpl?: string | TemplateRef<any>) {
    this.toasts.push({
      textOrTpl: textOrTpl ? textOrTpl : 'Ação realizada com sucesso.',
      classname: 'bg-success text-light',
      delay: 10000,
    });
  }

  error(textOrTpl?: string | TemplateRef<any>) {
    this.toasts.push({
      textOrTpl: textOrTpl ? textOrTpl : 'No momento não podemos realizar está ação, por favor tente novamente mais tarde.',
      classname: 'bg-danger text-light',
      delay: 15000,
    });
  }

  remove(toast: any) {
    this.toasts = this.toasts.filter((t) => t !== toast);
  }
}
